import { API_BASE_URL } from "@/libs/apis/commons";

import { FavoriteError, OrderError } from "./types";

export const ORDER_CREATION_API = `${API_BASE_URL}/orders/create`;

export const MAP_ORDER_ERROR_COPY = {
  [OrderError.SIGN_IN]: "Please sign in to purchase.",
  [OrderError.ONBOARDING_INCOMPLETE]: "Please complete onboarding to purchase.",
  [OrderError.NOT_ELIGIBLE]:
    "This sale is only available to [required-token] owners.",
  [OrderError.PURCHASE_LIMIT]: "You've reached your purchase limit.",
  [OrderError.ERROR]:
    "Something went wrong. Connect with our support team for assistance.",
  [OrderError.SOLD_OUT]:
    "Inventory is currently fully reserved. Check back in a few minutes.",
};

export const MAP_FAVORITE_ERROR_COPY = {
  [FavoriteError.SIGN_IN]: "Please sign in to favorite.",
  [FavoriteError.ERROR]:
    "Something went wrong. Connect with our support team for assistance.",
};
